import React from 'react';
// import clsx from 'clsx';
import PropTypes from 'prop-types';
import lifecycle from 'react-pure-lifecycle';
import { connect } from 'react-redux';
import { bindActionCreators } from "redux";
import { lighten, makeStyles } from '@material-ui/core/styles';
import {
  openModalDebitComp,
  debitsSelectedComp,
  debitsSelectedIDsComp,
  valueAmountComp
}  from "../../actions";
import { Table,
  TableBody,
  TableCell,
  TableHead,
  TablePagination,
  TableRow,
  TableSortLabel,
  Paper,
  IconButton,
} from '@material-ui/core';
import DeleteIcon from '@material-ui/icons/Delete';
import { cga, imoveis } from '../../helper/formatersMask';

function desc(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function stableSort(array, cmp) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = cmp(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  return stabilizedThis.map(el => el[0]);
}

function getSorting(order, orderBy) {
  return order === 'desc' ? (a, b) => desc(a, b, orderBy) : (a, b) => -desc(a, b, orderBy);
}

const headRows = [
  { id: 'tipoDebito', numeric: false, disablePadding: true, label: 'TIPO DE DÉBITO' },
  { id: 'nInscricao', numeric: true, disablePadding: false, label: 'Nº DE INSCRIÇÃO' },
  { id: 'local', numeric: true, disablePadding: false, label: 'LOCAL' },
  { id: 'valor', numeric: true, disablePadding: false, label: 'VALOR' },
];

function EnhancedTableHead(props) {
  const { order, orderBy, onRequestSort } = props;
  const createSortHandler = property => event => {
    onRequestSort(event, property);
  };

  return (
    <TableHead>
      <TableRow>
        <TableCell padding="checkbox" style={{'padding': '11px 40px 11px 16px', 'textAlign': 'left'}} />
        {headRows.map(row => (
          <TableCell
            key={row.id}
            align={'left'}
            sortDirection={orderBy === row.id ? order : false}
            style={{'padding': '11px 40px 11px 16px', 'textAlign': 'left'}}
          >
            <TableSortLabel
              active={orderBy === row.id}
              direction={order}
              onClick={createSortHandler(row.id)}
            >
            {row.label}
            </TableSortLabel>
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}

EnhancedTableHead.propTypes = {
  onRequestSort: PropTypes.func.isRequired,
  order: PropTypes.string.isRequired,
  orderBy: PropTypes.string.isRequired,
  rowCount: PropTypes.number.isRequired,
};

const useStyles = makeStyles(theme => ({
  root: {
    width: '100%',
    position: 'relative',
  },
  paper: {
    width: '100%',
    marginBottom: theme.spacing(2),
  },
  table: {
    minWidth: 750,
  },
  tableWrapper: {
    overflowX: 'auto',
  },
  tableCell: {
    padding: '11px 40px 11px 16px',
    color: '#636363',
  },
  highlight: {
    color:'#000',
    fontWeight: 500,
  },
  root2: {
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(1),
    minHeight: 51,
  },
  highlight2:
    theme.palette.type === 'light'
      ? {
          color: theme.palette.secondary.main,
          backgroundColor: lighten(theme.palette.secondary.light, 0.85),
        }
      : {
          color: theme.palette.text.primary,
          backgroundColor: theme.palette.secondary.dark,
        },
  spacer: {
    flex: '1 1 100%',
  },
  actions: {
    color: theme.palette.text.secondary,
  },
  title: {
    flex: '0 0 auto',
  },
}));

let rows = []

const methods = {
  componentWillMount(props) {
    rows = props.rows
  }
};

function EnhancedTable(props) {
  const classes = useStyles();
  const [order, setOrder] = React.useState('asc');
  const [orderBy, setOrderBy] = React.useState('name');
  const [selected, setSelected] = React.useState([]);
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(5);

  function handleRequestSort(event, property) {
    const isDesc = orderBy === property && order === 'desc';
    setOrder(isDesc ? 'asc' : 'desc');
    setOrderBy(property);
  }

  function handleDeleteItem(itemSelected){
       if(rows.length > 1){
      let rowsLoaded = rows

      let listaDeletada = rowsLoaded.filter(item => !itemSelected.includes(item.IdDebito))
      let debitsIds = props.props.debitsSelectedIDsValue.filter(id => !itemSelected.includes(id));
      let currentAmount = props.props.valueAmountValue

      rowsLoaded.forEach(itemLoaded => {
        if(itemLoaded.IdDebito === itemSelected){
          currentAmount = currentAmount - itemLoaded.ValorPagar
        }
      })

      if(currentAmount < 0){
        currentAmount = 0
      }

      rows = listaDeletada
      props.props.debitsSelectedIDsComp(debitsIds)
      props.props.debitsSelectedComp(listaDeletada)
      props.props.valueAmountComp(currentAmount)
      props.validaDataITIVExcluir(listaDeletada)
      setSelected([])

      if(((rows.length - 1)/rowsPerPage) < page)
        setPage(page - 1);
    } else {

      props.handleMinimumAmount(true)
    }
  }

  function handleChangePage(event, newPage) {
    setPage(newPage);
  }

  function handleChangeRowsPerPage(event) {
    setRowsPerPage(+event.target.value);
  }

  const isSelected = name => selected.indexOf(name) !== -1;

  function renderMask(row) {
    if(row.Tributo.Icone === 'IMOVEL')
      return imoveis(row.Contribuinte.NumInscricaoFormatado)
    return cga(row.Contribuinte.NumInscricaoFormatado)
  }

  return (
    <div className={classes.root}>
      <Paper className={classes.paper}>
        <div className={classes.tableWrapper}>
          <Table
            className={classes.table}
            aria-labelledby="tableTitle"
            size={'medium'}
          >
            <EnhancedTableHead
              order={order}
              orderBy={orderBy}
              onRequestSort={handleRequestSort}
              rowCount={rows.length}
            />
            <TableBody>
              {stableSort(rows, getSorting(order, orderBy))
                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map((row, index) => {
                  const isItemSelected = isSelected(row.IdDebito);
                  const labelId = `enhanced-table-checkbox-${index}`;
                  return (
                    <TableRow
                      hover
                      role="checkbox"
                      aria-checked={isItemSelected}
                      tabIndex={-1}
                      key={row.IdDebito}
                      selected={isItemSelected}
                    >
                      <TableCell className={classes.tableCell} padding="checkbox">
                        <IconButton aria-label="Remover" onClick={() => handleDeleteItem(row.IdDebito)}>
                          <DeleteIcon />
                        </IconButton>
                      </TableCell>
                      <TableCell className={`${classes.tableCell} ${classes.highlight}`} component="th" id={labelId} scope="row">
                        {row.Tributo.Nome}
                      </TableCell>
                      <TableCell className={classes.tableCell} align="left">{ renderMask(row)}</TableCell>
                      <TableCell className={classes.tableCell} align="left">{row.Contribuinte.EnderecoFormatado !== null ? row.Contribuinte.EnderecoFormatado : ""}</TableCell>
                      <TableCell className={classes.tableCell} align="right">R$ <span className={classes.highlight}>{row.ValorPagarVirgula}</span></TableCell>
                    </TableRow>
                  );
                })}
            </TableBody>
          </Table>
        </div>
        <TablePagination
          rowsPerPageOptions={[5, 10, 25]}
          component="div"
          count={rows.length}
          rowsPerPage={rowsPerPage}
          page={page}
          backIconButtonProps={{
            'aria-label': 'Página Anterior',
          }}
          nextIconButtonProps={{
            'aria-label': 'Próxima Página',
          }}
          labelDisplayedRows={
            ({ from, to, count }) => {
              return '' + from + '-' + to + ' de ' + count
            }
          }
          onChangePage={handleChangePage}
          onChangeRowsPerPage={handleChangeRowsPerPage}
          labelRowsPerPage={'Linhas por página:'}
        />
      </Paper>
    </div>
  );
}

const mapStateToProps = (store) => ({
  openModalDebit: store.cardDebitState.openModalDebitValue,
  valueAmountValue: store.cardDebitState.valueAmountValue,
  debitsSelectedValue: store.cardDebitState.debitsSelectedValue,
  debitsSelectedIDsValue: store.cardDebitState.debitsSelectedIDsValue,
})

const mapDispatchToProps = dispatch =>
  bindActionCreators({ openModalDebitComp, debitsSelectedComp, debitsSelectedIDsComp, valueAmountComp }, dispatch);

connect(
  mapStateToProps,
  mapDispatchToProps
)(EnhancedTable)

export default lifecycle(methods)(EnhancedTable);
